import React, { useRef, useState, useEffect, memo } from 'react';
import NoDataComponent from '../../no_data_component.jsx';
import LoadingIndicator from '../../../common/loading_indicator.jsx';
import { useSelector } from 'react-redux';
import { Chart } from '../../../../helpers/index.js';
export const DEFAULT_CHART_CONTAINER_CLASSES = ["chart-container"];
// TODO: Handle resize
function ChartContent({
    data,
    widgetId,
    chart_container_classes = [],
    renderBeforeContent = () => null,
    chart_type,
    formatData = () => {},
    getChartOptions = () => {},
    getChartPlugins = () => {return []},
    afterInitChart = (props) => {},
    dimensions,
    tooltip = null
}) {
    const chartRef = useRef(null);
    const chartInstance = useRef(null);
    const [loading, setLoading] = useState(false);
    const [noData, setNoData] = useState(true);
    const [chartData, setChartData] = useState();
    const settings = useSelector(state => state.dashboard.widgets[widgetId]?.settings)

    const initChart = () => {
        if (chartInstance.current){
          chartInstance.current.destroy();
        }
        if (chartRef.current && chartData) {
            chartInstance.current = new Chart(chartRef.current, {
                type: chart_type,
                data: chartData,
                options: getChartOptions({chartData, chartRef, ...settings}),
                plugins: getChartPlugins({chartData, chartRef}),
            });
            afterInitChart({chartData, chartRef});
        }
    };

    const dataLoaded = () => {
        const data = formatData();
        if (data.notConfigured) {
            setNoData(true);
            setLoading(false);
        } else {
            setChartData(data);
            setLoading(false);
            setNoData(false);
        }
    };

    useEffect(() => {
      dataLoaded();
    }, [data, settings])

    useEffect(() => {
        initChart();
    }, [chartData])

    return !loading ? (
      noData ? (
        <NoDataComponent />
      ) : (
        <div className="widget-content" style={{height: '100%'}}>
          {renderBeforeContent()}
          {/* style={{ position: "relative", width: dimensions.width, height: dimensions.height - this.constructor.ADDITIONAL_CONTENT_HEIGHT }} */}
          <div className={chart_container_classes.join(" ")}>
            {tooltip}
            <canvas ref={chartRef} {...(dimensions && {style: {position: 'relative', width: dimensions?.width, height: dimensions?.height}})} />
          </div>
        </div>
      )
    ) : (
      <LoadingIndicator />
    );
}

export default memo(ChartContent);
